<template>
    <div class="row text-right"
         v-if="permissionMainBranch && permissionMainBranch.permission_id === permission.readWrite">
        <v-spacer></v-spacer>
        <delete-button @click.native="deleteInfo" />
        <v-btn large @click.native="saveClose">Save & Close</v-btn>
        <save-button @click.native="saveInfo" />
    </div>
</template>

<script>
    import DeleteButton from "../../components/Button/DeleteButton";
    import PreviewButton from "../../components/Button/PreviewButton";
    import SaveButton from "../../components/Button/SaveButton";
    import {
        permissionMainBranch, role,
    } from "../../util/Permission";
    import {mapState} from "vuex";
    export default {
        name: "CommandButton",
        components: {
            SaveButton,
            PreviewButton,
            DeleteButton,
        },
        computed: {
            permissionMainBranch,
            ...mapState({
                form: state => {
                    return state.Branch.form;
                }
            })
        },
        data() {
            return {
                permission : null
            };
        },
        created() {
            this.permission = role;
        },
        methods:{
            deleteInfo(){
                this.$emit("delete-info")
            },
            saveInfo(){
                this.$emit("save-info")
            },
            saveClose(){
                this.$emit("save-close")
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "src/assets/css/variables.scss";
    .theme--light.v-btn:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
        color: black;
        display: block;
        border-radius: 20px;
        width: $width-button;
        border: 1px solid $submit-color;
        margin: $margin-button;
        height: $height-button;
    }
</style>
